<template>
  <Menu></Menu>
  <div id="box">
    <div v-if="loading" class="loadingSpinner"><span class="spinner-border"></span></div>
    <!-- =========================================================================================================== -->
    <div class="container mb-2">
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0 text-center">
          <h5 class="fw-bold d-inline-block bi-buildings-fill">&nbsp; Manage Branches</h5>
        </div>
        <div class="col-auto p-0 text-center">
          <button class="btn btn-dark w-100 bi-arrow-clockwise" @click="reloadData()" :disabled="loading">&nbsp; Reload</button>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0">
          <hr>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">

        <div class="col p-0">
          <div class="input-group w-100">
            <span class="input-group-text bi-search"></span>
            <input class="form-control" type="text" placeholder="Search by name" v-model.trim='filter'>
          </div>
        </div>
        
        <div class="col p-0">
        </div>

        <div class="col p-0">
        </div>
        
        <div class="col p-0">
          <button v-if="$store.getters.access('branch_add')" class="btn btn-success w-100" @click="showAddBranch()" :disabled="loading">
            <span class="bi-plus-circle">&nbsp; Add Branch</span>
          </button>
        </div>

      </div>
    </div>
    <!-- =========================================================================================================== -->
    <table class="table table-sm table-bordered table-striped table-hover table-fixed">
      <!-- ----------------------------------------------- -->
      <thead>
        <tr class="table-dark">
          <th>Name</th>
          <th class="w-40">Address</th>
          <th class="text-center w-50px"><span class="bi-gear"></span></th>
        </tr>
      </thead>
      <!-- ----------------------------------------------- -->
      <tbody style="height: calc(100vh - 190px)">        
        <tr v-for="branch in branches_filtered" :key="branch._id">
          <td>{{ branch.name }}</td>
          <td class="w-40">{{ branch.address }}</td>
          <td class="dropstart text-center w-50px">
            <a data-bs-toggle='dropdown' class="btn btn-sm btn-secondary p-1"><span class="bi-three-dots-vertical"></span></a>
            <ul class="dropdown-menu">
              <li v-if="$store.getters.access('branch_edit')"><a class="dropdown-item bi-pencil-fill" @click="showEditBranch(branch)">Edit</a></li>
              <li v-if="$store.getters.access('branch_del')"><a class="dropdown-item bi-trash text-danger" @click="delBranch(branch)">Delete</a></li>
            </ul>
          </td>
        </tr>
      </tbody>
      <!-- ----------------------------------------------- -->
    </table>
    <!-- =========================================================================================================== -->
    <div id="addBranchModal" ref="addBranchModal" class="modal fade">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Add New Branch</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Name</span>
              <input class="form-control" type="text" v-model.trim="newBranch.name">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">address</span>
              <input class="form-control" type="text" v-model.trim="newBranch.address">
            </div>

            <div class="input-group w-100 mb-2">
              <span class="input-group-text">
                <input class="branches form-check-input" type='checkbox' id="addAccess" v-model=newBranch.addAccess>
              </span>
              <label class="input-group-text flex-fill" for="addAccess">Add Access to all admins</label>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="addBranch()">Add</a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <div id="editBranchModal" ref="editBranchModal" class="modal fade">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Edit Branch: {{ editBranch.nameOriginal }}</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Name</span>
              <input class="form-control" type="text" v-model.trim="editBranch.name">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Address</span>
              <input class="form-control" type="text" v-model.trim="editBranch.address">
            </div>

            <div class="input-group w-100 mb-2">
              <span class="input-group-text">
                <input class="branches form-check-input" type='checkbox' id="addAccess_edit" v-model=editBranch.addAccess>
              </span>
              <label class="input-group-text flex-fill" for="addAccess_edit">Add Access to all admins</label>
            </div>

          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="saveBranch()">Save</a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
  </div>

</template>
<!-- ******************************************************** -->
<script>
  const $ = require('jquery');
  export default {
    name: 'BranchesPage',
    data(){
      return {
        loading: false,
        branches: [],
        filter: '',
        newBranch:{
          name: '',
          address: '',
          addAccess: false, 
        },
        editBranch:{
          id: '',
          nameOriginal: '',
          name: '',
          address: '',
          addAccess: false, 
        },
      }
    },
    created() {
      this.reloadData();
    },
    mounted(){
    },
    //**********************************************************
    computed:{
      branches_filtered(){
        let filter = this.filter.toLowerCase();
        return this.branches.filter((x)=>x.name.toLowerCase().includes(filter));
      }
    },
    //**********************************************************
    methods:{
      //**********************************************************
      async reloadData(){
        this.loading = true;
        this.branches = [];
        var ack = await this.$service.getBranches();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.branches = ack.data;
        }
        this.loading = false;
      },
      //**********************************************************
      async showAddBranch(){
        this.clearFields();
        $('#addBranchModal').modal('show');
      },
      //**********************************************************
      async addBranch(){
        this.loading = true;
        await this._addBranch();
        this.loading = false;
      },
      //**********************************************************
      async _addBranch(){
        if(!this.newBranch.name || !this.newBranch.address){
          return this.$toast('Some Fields are empty', 'warning');
        }
        var ack = await this.$service.addBranch({
          name: this.newBranch.name,
          address: this.newBranch.address,
          addAccess: this.newBranch.addAccess,
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        $('#addBranchModal').modal('hide');
        this.$toast('Branch Added Successfuly', 'success');
        this.reloadData();
      },
      //**********************************************************
      async showEditBranch(branch){
        this.editBranch.id = branch._id;
        this.editBranch.nameOriginal = branch.name;
        this.editBranch.name = branch.name;
        this.editBranch.address = branch.address;
        this.editBranch.addAccess = false;
        $('#editBranchModal').modal('show');
      },
      //**********************************************************
      async saveBranch(){
        this.loading = true;
        await this._saveBranch();
        this.loading = false;
      },
      //**********************************************************
      async _saveBranch(){
        if(!this.editBranch.name || !this.editBranch.address){
          return this.$toast('Some Fields are empty', 'warning');
        }
        var ack = await this.$service.editBranch({
          id: this.editBranch.id,
          name: this.editBranch.name,
          address: this.editBranch.address,
          addAccess: this.editBranch.addAccess,
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        $('#editBranchModal').modal('hide');
        this.$toast('Branch Saved Successfuly', 'success');
        this.reloadData();
      },
      //**********************************************************
      async delBranch(branch){
        var reply = await this.$swal.fire({
          title: "Confirm Delete",
          html: `Are you sure you want to delete the branch <b>${branch.name}</b>`,
          icon: "error", showCancelButton: true, focusCancel: true,
          confirmButtonText: "Confirm Delete", confirmButtonColor: "#d33", 
        });
        if(!reply.isConfirmed) return;
        this.loading = true;
        var ack = await this.$service.delBranch({ id: branch._id });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.$toast('Branch Deleted Successfuly', 'success');
          this.reloadData();
        }
        this.loading = false;
      },
      //**********************************************************
      async clearFields(){
        this.newBranch = {
          name: '',
          address: '',
          addAccess: false, 
        };
      },
      //**********************************************************
      //**********************************************************
      //**********************************************************
      //**********************************************************
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
</style>
  